import { render, staticRenderFns } from "./SurveyScores.vue?vue&type=template&id=60e93610"
import script from "./SurveyScores.vue?vue&type=script&lang=js"
export * from "./SurveyScores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports